var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"divData",class:{ 'table-collapsed': _vm.tableCollapsed },style:(`min-width: ${_vm.tableWidth}px;width: ${_vm.tableWidth}px;`)},[_c('data-container')],1),_c('div',{staticClass:"divMap"},[_c('vue-map')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }